/** @format */

import { IChain } from '@shared/data-access/interfaces';

export const chain: IChain = {
	aemData: {
		title: 'Read & Watch',
		subText: 'The Latest On Golf'
	},
	authStrategy: 'cookie',
	bopisFlag: true,
	bopisLocationDefault: -2,
	cartUrlParameters: '',
	checkoutUrlBase: 'SinglePageCheckout',
	checkoutUrlParameters: '?storeId=10701&catalogId=10051',
	checkoutConfirmationUrlParameters: 'catalogId=10051&langId=-1&storeId=10701',
	catalogIdCollections: '10601',
	catalogIdContent: '10101',
	catalogIdSales: '10051',
	chainIdentifier: 'GolfGalaxy',
	chainIdentifierAbbr: 'gg',
	chainMarketingIdentifierAbbr: 'gg',
	chainIdentifierCookie: '121',
	chainIdentifierCookieAOS: '125',
	chainName: 'Golf Galaxy',
	chainCartImage: false,
	chainCartUrl: '/OrderItemDisplay',
	chainInitial: 'G',
	chainBopisIcon: 'GGBopis.svg',
	chatUrl: 'https://ggcep.custhelp.com/app/chat/chat_launch',
	holidayOfferCode: 'EM1219GBP3X',
	isaFlag: true,
	masterCatalogId: '10001',
	metaCanonical: 'https://www.golfgalaxy.com',
	metaCanonicalHost: 'golfgalaxy',
	metaDescription:
		'Visit Golf Galaxy to shop a wide selection of golf clubs, apparel & equipment from the top brands! Improve your game with services from our expert golf pros',
	metaTitle: 'Golf Galaxy - Official Website',
	myAccountUrlLoggedIn: '/MyAccount/AccountSummary',
	myAccountUrlAuthListSignIn: '/MyAccount/Lists',
	myAccountUrlLoggedOut: '/LogonForm',
	nestjsProductAPIVersion: 'v6',
	priceStringIndicator: 'golfgalaxy',
	productAPIVersion: 'v5',
	proTipsFlag: false,
	qAndAFlag: true,
	rewardsAccountName: 'ScoreCard',
	rewardsAccountImage: 'scoreCard.svg',
	searchDex: {
		includeType: {
			meta: 'm',
			body: 'b',
			footer: 'f'
		},
		pageType: {
			category: 'c',
			product: 'p'
		}
	},
	serviceIdentifier: 'golfgalaxy',
	serviceIdentifierAbbr: 'gg',
	sessionCamIdentifier: 'RES-PDP-GG',
	storeId: '10701',
	userRegistrationFormUrl: '/UserRegistrationForm',
	footerData: {
		social: {
			youtube: 'https://youtube.com/golfgalaxy',
			twitter: 'https://twitter.com/golfgalaxy',
			facebook: 'https://facebook.com/golfgalaxy',
			pinterest: 'https://pinterest.com/golfgalaxy',
			instagram: 'https://www.instagram.com/golfgalaxy',
			tiktok: 'https://www.tiktok.com/@golfgalaxy'
		},
		oracleChat: 'https://ggcep.custhelp.com/app/chat/chat_launch',
		copyright: `&copy; ${new Date().getFullYear()} Golf Galaxy`
	},
	feedbackSurveyId: '5458',
	sizeChartSurveyId: '16837',
	cartTitle: 'Cart',
	crossChainBopisPartners: ['dsg'],
	crossChainLogoSVG: {
		dickssportinggoods: 'store_pickup.svg'
	},
	crossChainLogoSVGV2: 'dsg-store-pickup',
	logoSVG: 'GG_pickup_logo.svg',
	logoSVGV2: 'gg-store-pickup',
	vhHeader: '121',
	auth0: {
		enabled: true
	},
	chainFooterUrls: {
		returns: {
			text: 'Returns',
			link: '/s/return-policy'
		},
		shippingRates: {
			text: 'Shipping Information',
			link: '/s/shipping-information'
		},
		productAvailability: null,
		promoExclusions: {
			text: 'Promotion Exclusions',
			link: '/s/promotion-exclusions'
		},
		contactCustomerService: {
			text: 'Contact Customer Service',
			link: '/s/customer-service'
		},
		privacyPolicy: {
			text: 'Privacy Policy',
			link: '/s/privacy-policy'
		},
		termsOfUse: {
			text: 'Terms of Use',
			link: '/s/terms-of-use'
		},
		californiaDisclosures: {
			text: 'California Disclosures',
			link: '/s/california-disclosures'
		},
		doNotSellMyInfoCAResidentsOnly: {
			text: 'Your Privacy Choices',
			link: '/s/donotsell'
		},
		accessibilityPolicy: {
			text: 'Accessibility Policy',
			link: '/s/web-content-accessibility-policy'
		}
	},
	shippingIcon: 'ggTruck.svg',
	shippingInfoIcon: 'info',
	apiVersion: 2,
	seoIdentifier: 'golfgalaxy',
	rewards: {
		image: 'scoreCard.svg',
		programName: 'ScoreCard'
	},
	xChannel: '15108',
	supportNumber: '800‑287‑9060',
	simpleHeaderLogoUrl: 'https://images.dickssportinggoods.com/marketing/gg_logo.svg',
	partyServiceId: 3,
	preferenceIds: {
		nfl: 11,
		brand: 2,
		size: 5,
		color: 8
	}
};
